import "./components/_scaleRoot";
$(".inner").scaleRoot({
  scaleMode: viewportIsMobile($("body").outerWidth())
    ? "containWidth"
    : "cover",
});

// $(".inner:not(.detect-iframe > .outer > #scrollContent, .popup-sn2020 .inner)").scaleRoot({
//     scaleMode: (viewportIsMobile($("body").outerWidth())) ? 'containWidth' : 'cover'
// });

function viewportIsMobile(width) {
  return width < 1025;
}

function initSection4TouchPager() {
  var $section = $(".section--4");
  if ($section.length === 0) {
    return;
  }

  var $wrapper = $section.find(".section--4__content .wrapper").first();
  if ($wrapper.length === 0 || $wrapper.find(".box-item").length < 12) {
    return;
  }

  var currentPage = 1;
  var startX = 0;
  var startY = 0;
  var dragging = false;
  var threshold = 40;

  function applyPage() {
    $section.addClass("section4-touch-mode");
    $section.toggleClass("section4-page-1", currentPage === 1);
    $section.toggleClass("section4-page-2", currentPage === 2);
  }

  applyPage();

  function handleSwipeEnd(endX, endY) {
    var deltaX = endX - startX;
    var deltaY = endY - startY;

    if (Math.abs(deltaX) < threshold || Math.abs(deltaX) <= Math.abs(deltaY)) {
      return;
    }

    if (deltaX < 0 && currentPage === 1) {
      currentPage = 2;
      applyPage();
    } else if (deltaX > 0 && currentPage === 2) {
      currentPage = 1;
      applyPage();
    }
  }

  // Button navigation
  $section.find(".btn__prev").on("click", function (e) {
    e.preventDefault();
    if (currentPage === 2) {
      currentPage = 1;
      applyPage();
    }
  });

  $section.find(".btn__next").on("click", function (e) {
    e.preventDefault();
    if (currentPage === 1) {
      currentPage = 2;
      applyPage();
    }
  });
}

import "./components/_lightbox";

import MobileDetect from "mobile-detect";

var md = new MobileDetect(window.navigator.userAgent);
$(window).on("load", function () {
  $("#loading").each(function () {
    $("#loading").removeClass("active");
  });
});

if ($(".btn-download").length > 0) {
  var link = "";
  switch (md.os()) {
    case "AndroidOS":
      link = $(".btn-download").data("ggplay");
      $(".btn-download").attr("href", link);
      break;
    case "iOS":
      link = $(".btn-download").data("appstore");
      $(".btn-download").attr("href", link);
      break;
    default:
  }
}
$(document).ready(function () {
  //randomBg();
  initSection4TouchPager();

  if (isMobile.any()) {
    $("#floating .nav-top-mb").removeClass("nav-top-promotion");
  } else {
    $("#floating .nav-top-promotion").removeClass("nav-top-mb");
  }
  $(".scrollTop").each(function () {
    $(this).on("click", function () {
      $("html, body").animate({ scrollTop: 0 }, 400);
    });
  });
  var close = true;
  $("#asideRightToggle").click(function (e) {
    e.preventDefault();
    if (!close) {
      $(this).addClass("active");
      $(".aside-right").addClass("active");
      close = true;
    } else {
      $(this).removeClass("active");
      $(".aside-right").removeClass("active");
      close = false;
    }
  });
  if ($(".section--2").length > 0) {
    var numbernb = parseInt($(".number-nb").text().replace(/\./g, ""));
    $(".section--2 .box-item").each(function () {
      if (!$(this).hasClass("received")) {
        var numberact = parseInt($(this).find(".icon").text());
        if (numberact <= numbernb) {
          $(this).addClass("active");
        } else {
          $(this).addClass("napnb");
        }
      }
    });
  }
});

var isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Desktop: function () {
    return navigator.userAgent.match(/Windows NT/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function () {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
    );
  },
};
var IsOpen = false;
$(".opennav").on("click", function (e) {
  e.preventDefault();
  if (!IsOpen) {
    $(".sub-nav-mb").addClass("Open");
    $(".opennav").addClass("toclose is-active");
    IsOpen = true;
  } else {
    $(".sub-nav-mb").removeClass("Open");
    $(".opennav").removeClass("toclose is-active");
    IsOpen = false;
  }
});

import "./components/_content-tab";
// import "./components/_frame-mp";
//import "./components/_control-side";
// import "./components/_progress";
import "./components/_watchIFrame";
